/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Status,
  Status$inboundSchema,
  Status$outboundSchema,
} from "./status.js";

/**
 * Function call output item: The output payload returned from a function tool call.
 */
export type FunctionToolCallOutputWithId = {
  type: "function_call_output";
  callId: string;
  output: string;
  /**
   * The unique ID of the message.
   */
  id: string;
  /**
   * The processing status of an individual item. 'in_progress' means currently processing, 'completed' means finished successfully, 'incomplete' means processing stopped before completion.
   */
  status?: Status | undefined;
  /**
   * The ID of the response that created this item, if any.
   */
  responseId?: string | null | undefined;
  /**
   * Metadata from the response that created this item, if any.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const FunctionToolCallOutputWithId$inboundSchema: z.ZodType<
  FunctionToolCallOutputWithId,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("function_call_output"),
  call_id: z.string(),
  output: z.string(),
  id: z.string(),
  status: Status$inboundSchema.optional(),
  response_id: z.nullable(z.string()).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "call_id": "callId",
    "response_id": "responseId",
  });
});
/** @internal */
export type FunctionToolCallOutputWithId$Outbound = {
  type: "function_call_output";
  call_id: string;
  output: string;
  id: string;
  status?: string | undefined;
  response_id?: string | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const FunctionToolCallOutputWithId$outboundSchema: z.ZodType<
  FunctionToolCallOutputWithId$Outbound,
  z.ZodTypeDef,
  FunctionToolCallOutputWithId
> = z.object({
  type: z.literal("function_call_output"),
  callId: z.string(),
  output: z.string(),
  id: z.string(),
  status: Status$outboundSchema.optional(),
  responseId: z.nullable(z.string()).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    callId: "call_id",
    responseId: "response_id",
  });
});

export function functionToolCallOutputWithIdToJSON(
  functionToolCallOutputWithId: FunctionToolCallOutputWithId,
): string {
  return JSON.stringify(
    FunctionToolCallOutputWithId$outboundSchema.parse(
      functionToolCallOutputWithId,
    ),
  );
}
export function functionToolCallOutputWithIdFromJSON(
  jsonString: string,
): SafeParseResult<FunctionToolCallOutputWithId, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FunctionToolCallOutputWithId$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FunctionToolCallOutputWithId' from JSON`,
  );
}
